import { checkLimit } from "../../../../../../util/varibles/global";
import { IOperation } from '../../../../../../util/varibles/interface';
import EtaOperation from "../../../../_components/EtaOperation";
import styles from './style.module.scss';

const Harvest: React.FC<IOperation> = ({ vessel, operation }) => {
    const {
        sub_operations,
        site_name,
        factory_name,
        sites = [],
        vessel_name = ""
    } = operation;
    const { name = vessel_name } = vessel || {};

    const startPlace = sites.length === 0
        ? [site_name, sub_operations.map((item: any) => item.unit_id).join(', ')].join(' - ')
        : sites.map((item: any) => {
            return [item.name, sub_operations.reduce((list: any, sub: any) =>
                sub.site_id === item.id ? [...list, sub.unit_id] : list
                , []).join(', ')].join(' - ')
        }).join(' | ')

    const voyage = name + startPlace + factory_name;

    const style: any = { '--width-indent': -(checkLimit(0, undefined, voyage.length - 58) * 7) + 'px' }

    return <>
        <div className={styles['line-info']}>
            <div className='flex align-items-center text-truncate'>
                <span className="mr-2">
                    {name}
                </span>
                <EtaOperation data={operation} />
            </div>
        </div>
        <div className={styles['line-info']}>
            <div className='animation-ellipsis'>
                <div
                    className='animation-ellipsis-text h-24 flex align-items-center'
                    style={style}
                    title={[startPlace, factory_name].join(' -> ')}
                >
                    <span>{startPlace}</span>
                    <span className='arrow-right' />
                    <span>{factory_name}</span>
                </div>
            </div>
        </div>
    </>;
}

export default Harvest;
